import React from 'react';
import {
  Container,
  Header,
  SpaceBetween,
  ColumnLayout,
  Box,
  Table,
  Button,
  ExpandableSection,
  StatusIndicator
} from '@cloudscape-design/components';

const DomainOverview = ({ domains, onSelectDomain, synthesisMetadata }) => {
  return (
    <SpaceBetween size="l">
      {/* Domain Summary Cards */}
      <ColumnLayout columns={domains.length}>
        {domains.map(domain => (
          <Container
            key={domain.name}
            header={
              <Header
                variant="h3"
                actions={<Button onClick={() => onSelectDomain(domain)}>View Details</Button>}
              >
                {domain.name}
              </Header>
            }
          >
            <SpaceBetween size="m">
              <Box variant="awsui-key-label">
                {domain.context.bounded_context}
              </Box>
              <StatusIndicator type={
                domain.context.domain_type === 'CORE' ? 'success' :
                domain.context.domain_type === 'SUPPORTING' ? 'info' : 'warning'
              }>
                {domain.context.domain_type}
              </StatusIndicator>
              <Box variant="small">
                {domain.context.business_capability}
              </Box>
              <ExpandableSection header="Domain Scope">
                <ul>
                  {domain.context.domain_scope.map((scope, i) => (
                    <li key={i}>{scope}</li>
                  ))}
                </ul>
              </ExpandableSection>
            </SpaceBetween>
          </Container>
        ))}
      </ColumnLayout>

      {/* Synthesis Decisions */}
      <Container
        header={
          <Header variant="h3">Synthesis Decisions</Header>
        }
      >
        <Table
          columnDefinitions={[
            {
              id: 'decision',
              header: 'Decision',
              cell: item => item.decision
            },
            {
              id: 'rationale',
              header: 'Rationale',
              cell: item => item.rationale
            },
            {
              id: 'impact',
              header: 'Impact Assessment',
              cell: item => (
                <ExpandableSection header="View Impact">
                  <SpaceBetween size="xs">
                    <Box>Business: {item.impact_assessment.business_impact}</Box>
                    <Box>Technical: {item.impact_assessment.technical_impact}</Box>
                    <Box>Operational: {item.impact_assessment.operational_impact}</Box>
                  </SpaceBetween>
                </ExpandableSection>
              )
            }
          ]}
          items={synthesisMetadata.final_decisions}
          variant="container"
        />
      </Container>
    </SpaceBetween>
  );
};

export default DomainOverview;
